import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
import { CurrencyRateSettingsService } from '../services/currencyRate.service.js'
const service = new CurrencyRateSettingsService();

// Branch module state
export const state = {
  currencyRateSettings: [],
  localCurrencySetting: {}
};

// Branch module mutations
export const mutations = {
  ...make.mutations(state)
};

// Branch module actions
export const actions = {
  /**
   * Fetch all Currency Rate Settings
   * @param {*} Object - Vuex context
   * @returns Array - Currency Rate Settings
   */
  fetchCurrencyRateSettings: async ({ commit }) => {
    try {
      const { data } = await service.getCurrencyRateSettings();
      const localCurrency = data.find(currency => currency.isLocal);
      commit('SET_CURRENCY_RATE_SETTINGS', data);
      commit('SET_LOCAL_CURRENCY_SETTING', localCurrency);
      return data
    } catch (error) {
      Logger.error('fetching currency rate settings');
      throw error;
    }
  },

    /**
   * Fetch all Currency Rate Settings
   * @param {*} Object - Vuex context
   * @returns Array - Currency Rate Settings
   */
  updateCurrencyRateSetting: async ({ commit }, {  id, payload }) => {
    try {
      const { data } = await service.updateCurrencyRateSetting({ id, payload });
      return data
    } catch (error) {
      Logger.error('updating currency rate settings');
      throw error;
    }
  },

};

// Branch module getters
export const getters = make.getters(state);
